import styled from 'styled-components';

const SmallText = styled.p`
  font-size: 12px;
  line-height: 1.6;
  white-space: break-spaces;
`;

export default SmallText;
